import React from 'react';
import ExternalRedirect from './ExternalRedirect';
import { NETWORK_SELECTION } from '../constants';
import { generateLPBondsChainRoutes } from '../utils/helper';

const Notfound = React.lazy(() => import('./Notfound'));
const Portfolio = React.lazy(() => import('./Portfolio'));
const Settings = React.lazy(() => import('./Settings'));
const HomePage = React.lazy(() => import('./HomePage'));
const LiquidityBonds = React.lazy(() => import('./LiquidityBonds'));
const LPBondsLandingPage = React.lazy(() => import('./LiquidityBonds/LandingPage'));
const LPBondsAssetPage = React.lazy(() => import('./LiquidityBonds/AssetPage'));
const LPBondsListItemForSale = React.lazy(() => import('./LiquidityBonds/ListItemForSale'));
const Activity = React.lazy(() => import('./Activity'));
const GetGMI = React.lazy(() => import('./GetGMI'));
const GetGMIChainPage = React.lazy(() => import('./GetGMI/ChainPage'));
const Stats = React.lazy(() => import('./Stats'));
const TokenizeBond = React.lazy(() => import('./TokenizeBond'));
const LitePaper = React.lazy(() => import('./LitePaper'));
const FAQ = React.lazy(() => import('./FAQ'));
const ArbConsole = React.lazy(() => import('./ArbConsole'));

// LP Bonds page components for route generation
const LP_BONDS_COMPONENTS = {
  LandingPage: LPBondsLandingPage,
  CollectionPage: LiquidityBonds,
  AssetPage: LPBondsAssetPage,
  SellPage: LPBondsListItemForSale,
};

// LP Bonds chain slugs derived from NETWORK_SELECTION (single source of truth)
const LP_BONDS_CHAIN_SLUGS = NETWORK_SELECTION.map((network) => network.label.toLowerCase());

// Generate all LP Bonds chain routes
const lpBondsChainRoutes = LP_BONDS_CHAIN_SLUGS.flatMap((slug) =>
  generateLPBondsChainRoutes(slug, LP_BONDS_COMPONENTS),
);

export const routes = [
  {
    path: '/',
    component: HomePage,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
    fullScreen: true,
  },
  {
    path: '/lp-bonds',
    component: LPBondsLandingPage,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
    fullScreen: true,
  },
  {
    path: '/portfolio',
    component: Portfolio,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/lite-paper',
    component: LitePaper,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/faq',
    component: FAQ,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/stats',
    component: Stats,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/fractionalize',
    component: TokenizeBond,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/get-gmi',
    component: GetGMI,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/get-gmi/:chain',
    component: GetGMIChainPage,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/portfolio/:address',
    component: Portfolio,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  // LP Bonds chain routes (dynamically generated)
  ...lpBondsChainRoutes,
  {
    path: '/account/settings',
    component: Settings,
    meta: {
      needAuth: true,
      needConnectWallet: true,
    },
  },
  {
    path: '/activity',
    component: Activity,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/team',
    component: () => <ExternalRedirect to="https://team.gonnamakeit.com" />,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '/arb-console',
    component: ArbConsole,
    exact: true,
    meta: {
      needAuth: false,
      needConnectWallet: false,
    },
  },
  {
    path: '*',
    component: Notfound,
  },
];
